export default __webpack_public_path__ + "static/large-headings-dont-cdb702049b851d83a850671fcc7e62b45211fc6b443c5733a0afbadf50bfdad6.png";